// extracted by mini-css-extract-plugin
module.exports = {"termsSection":"TermsPage_termsSection__1JaUY","termsWrapper":"TermsPage_termsWrapper__3kreh","fadeIn":"TermsPage_fadeIn__2wEnk"};